import useLoadWidget from "../hooks/useLoadWidget";
import React from "react";
import { WIDGET_URL } from "../api";
import ReviseAnswerModal from "./ReviseAnswerModal";
import PrimaryButton from "./PrimaryButton";
import SectionHeader from "./SectionHeader";

const ChatWidget = ({
  onSendMessage,
  test = false,
  disabled = false,
  showHeading = true,
}) => {
  const {
    onResetConversation,
    onLoad,
    reviseAnswerData,
    showReviseModal,
    setShowReviseModal,
  } = useLoadWidget({
    test,
    onSendMessage,
  });

  return (
    <div className="relative">
      {showHeading && test && !disabled && (
        <div className="mb-6">
          <SectionHeader
            title="Test"
            description="Ask any questions to your AI agent to test they’re knowledge. Messages in testing do not count towards your message limit."
          >
            <PrimaryButton
              type="button"
              onClick={onResetConversation}
              startIcon={
                <svg
                  className="size-6"
                  width="100%"
                  height="100%"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M22 10C22 10 19.995 7.26822 18.3662 5.63824C16.7373 4.00827 14.4864 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.1031 21 19.5649 18.2543 20.6482 14.5M22 10V4M22 10H16"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              }
            >
              <span className="text-nowrap">Reset Conversation</span>
            </PrimaryButton>
          </SectionHeader>
        </div>
      )}

      <iframe
        className="w-full min-h-[55vh]"
        id="support-magic-widget-iframe"
        src={`${WIDGET_URL}/chat.html`}
        title="Live Chat Widget"
        onLoad={onLoad}
      />

      <ReviseAnswerModal
        defaultValues={reviseAnswerData}
        open={showReviseModal}
        onClose={() => {
          setShowReviseModal(false);
        }}
      />

      {disabled && (
        <div className="absolute inset-0 bg-transparent z-10 pointer-events-auto cursor-not-allowed" />
      )}
    </div>
  );
};

export default ChatWidget;
